import { createContext } from 'react';
import type { SessionStore, SessionStoreInstance } from '@/store/client';

export interface SessionContentsContextProps {
  staticSessionStore: SessionStore;
  sessionStoreInstance: SessionStoreInstance;
  canMention?: boolean;
  hideMembers?: boolean;
}

export const sessionContentsContext = createContext<SessionContentsContextProps>({} as never);

export function useSessionContentsContext() {
  return useContext(sessionContentsContext);
}
